import { render } from "./NotifyAlert.vue?vue&type=template&id=6a2c9e0e&scoped=true"
import script from "./NotifyAlert.vue?vue&type=script&lang=js"
export * from "./NotifyAlert.vue?vue&type=script&lang=js"

import "./NotifyAlert.vue?vue&type=style&index=0&id=6a2c9e0e&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\attendance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2c9e0e"]])

export default __exports__